import { MessagesState } from '../types.ts';

import { MESSAGE_SENDER } from '../../constants.ts';
import { createReducer } from '../../utils/createReducer.ts';
import { createComponentMessage, createLinkSnippet, createNewMessage } from '../../utils/messages.ts';
import {
  ADD_COMPONENT_MESSAGE,
  ADD_NEW_LINK_SNIPPET,
  ADD_NEW_RESPONSE_MESSAGE,
  ADD_NEW_USER_MESSAGE,
  DELETE_MESSAGES,
  DROP_MESSAGES,
  HIDE_AVATAR,
  MARK_ALL_READ,
  MARK_ALL_READ2,
  MessagesActions,
  SET_BADGE_COUNT
} from '../actions/types.ts';

const initialState = {
  messages: [],
  badgeCount: 0
};

const messagesReducer = {
  [ADD_NEW_USER_MESSAGE]: (state: MessagesState, { text, showClientAvatar, id }) =>
    ({ ...state, messages: [...state.messages, createNewMessage(text, MESSAGE_SENDER.CLIENT, id)]}),

  [ADD_NEW_RESPONSE_MESSAGE]: (state: MessagesState, { text, id }) =>
    ({ ...state, messages: [...state.messages, createNewMessage(text, MESSAGE_SENDER.RESPONSE, id)], badgeCount: state.badgeCount + 1 }),

  [ADD_NEW_LINK_SNIPPET]: (state: MessagesState, { link, id }) =>
    ({ ...state, messages: [...state.messages, createLinkSnippet(link, id)] }),

  [ADD_COMPONENT_MESSAGE]: (state: MessagesState, { component, props, showAvatar, id }) => {
    return { ...state, messages: [...state.messages, createComponentMessage(component, props, showAvatar, id)] };
  },

  [DROP_MESSAGES]: (state: MessagesState) => ({ ...state, messages: [] }),

  [HIDE_AVATAR]: (state: MessagesState, { index }) => state.messages[index].showAvatar = false,

  [DELETE_MESSAGES]: (state: MessagesState, { count, id }) =>
  ({
    ...state,
    messages: id
      ? state.messages.filter((_, index) => {
        const targetMsg = state.messages.findIndex(tMsg => tMsg.customId === id)
        return index < targetMsg - count + 1 || index > targetMsg
      })
      : state.messages.slice(0, state.messages.length - count)
  }),

  [SET_BADGE_COUNT]: (state: MessagesState, { count }) => ({ ...state, badgeCount: count }),

  [MARK_ALL_READ]: (state: MessagesState) =>
    ({ ...state, messages: state.messages.map(message => ({ ...message, unread: false })), badgeCount: 0 }),

  [MARK_ALL_READ2]: (state: MessagesState) =>
    ({ ...state, messages: state.messages.map(message => ({ ...message, status: false })), badgeCount: 0 })
}

const rootReducer = (state = initialState, action: MessagesActions) => createReducer(messagesReducer, state, action)

export default rootReducer;
